import "./styles.scss";

import { useTranslation } from "react-i18next";

import { useDashboard } from "context/webmaster/dashboard";
import { useTasks } from "context/webmaster/tasks";

import DashboardContentLayout from "components/layouts/DashboardContentLayout";
import PageLoader from "components/PageLoader";
import ScrollTopMobile from "components/ScrollTopMobile";
import Notifications from "page_components/shared/dashboard/Notifications";
import TaskSummary from "page_components/shared/dashboard/TaskSummary";
import { DeadlineTasks } from "./components";

import useResponsive from "libs/helpers/useResponsive";

const actions = [
  {
    type: "send_notification",
  },
];

const mainClass = "dashboard-webmaster-content";

const DashboardWebmasterContent = () => {
  const { t } = useTranslation();
  const { init_loading } = useDashboard();
  const { max } = useResponsive();
  const { data } = useTasks();

  return (
    <DashboardContentLayout actions={actions}>
      <div className={mainClass}>
        {init_loading ? (
          <PageLoader />
        ) : (
          <>
            <div className={`${mainClass}__row`}>
              <div className={`${mainClass}__col ${mainClass}__col--summary`}>
                <TaskSummary
                  title={t("Summary of tasks assigned to you")}
                  data={data}
                />
              </div>
              <div
                className={`${mainClass}__col ${mainClass}__col--notifications`}
              >
                <Notifications />
              </div>
            </div>
            <div className={`${mainClass}__row`}>
              <div className={`${mainClass}__col`}>
                <DeadlineTasks />
              </div>
            </div>
            {max.sm && <ScrollTopMobile />}
          </>
        )}
      </div>
    </DashboardContentLayout>
  );
};

export default DashboardWebmasterContent;
